import React from 'react'
import { Link } from 'react-router-dom'
import SearchUI from '../../../widgets/input/SearchUI'
import MessageUI from '../../../widgets/output/MessageUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import IconButtonLinkUI from '../../../widgets/action/IconButtonLinkUI'
import './ProjectList.css'

const ProjectListUI = ({context, messageList, projectList,
    alphaSort, timeSort, projectFilter, templateFilter, activeFilter, archivedFilter, searchFilter,
    onRefreshClick, onAlphaSortClick, onTimeSortClick,
    onProjectFilterClick, onTemplateFilterClick, onActiveFilterClick, onArchivedFilterClick,
    onSearchFilterChange
  }) =>
  <div className='prj_projects'>

    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          alphaSort={alphaSort}
          timeSort={timeSort}
          onRefreshClick={onRefreshClick}
          onAlphaSortClick={onAlphaSortClick}
          onTimeSortClick={onTimeSortClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          projectFilter={projectFilter}
          templateFilter={templateFilter}
          searchFilter={searchFilter}
          onProjectFilterClick={onProjectFilterClick}
          onTemplateFilterClick={onTemplateFilterClick}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI className='data_tbl'>
      {
        projectList.map((project, i) =>
          <ProjectRowUI key={i} context={context} project={project} />
        )
      }
    </LRTableBodyUI>

    <LRTableActionsUI location='bottom'
      left={<span />}
      right={
        <ActionBtmRightUI
          context={context}
          messageList={messageList}
          activeFilter={activeFilter}
          archivedFilter={archivedFilter}
          onActiveFilterClick={onActiveFilterClick}
          onArchivedFilterClick={onArchivedFilterClick}
        />
      }
    />
  </div>

const ProjectRowUI = ({context, project, messageList}) =>
  <LRTableRowUI
    context={context}
    left={<RowLeftUI context={context} project={project} />}
    right={<RowRightUI context={context} project={project} />}
  />

const RowLeftUI = ({context, project}) =>
  <Link to={`/projects/${project.projectId}/tasks`}>
    <div>
      {project.projectName}
      {
        project.projectType === 'template' &&
        <span className='icon icon-cube tag'></span>
      }
      {
        project.visibility === 'all' &&
        <span className='icon icon-globe tag'></span>
      }
    </div>
    {
      project.description &&
      <div className='g_muted g_small g_m_top_25'>
        {project.description}
      </div>
    }
  </Link>

const RowRightUI = ({context, project}) =>
  <div className='g_flex_h'>
    {
      project.status === 'active' && project.projectType === 'project' &&
      project.permissionList.includes('prj_manage') &&
      <Link className='icon icon-bell-o tag' to={`/projects/${project.projectId}/alerts`}>
      </Link>
    }
    {
      project.permissionList.includes('prj_manage') &&
      <Link className='icon icon-pencil tag' to={`/projects/${project.projectId}/update`}>
      </Link>
    }
  </div>

const ActionLeftUI = ({context, messageList, alphaSort, timeSort,
    onRefreshClick, onAlphaSortClick, onTimeSortClick
  }) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
    {
      context.permissions && context.permissions.includes('acc_manage') &&
      <IconButtonLinkUI messageList={messageList} icon='icon-plus' to='/projects/create' labelKey='c_create_project' />
    }
    <IconButtonUI messageList={messageList} icon='icon-sort-alpha-asc' selected={alphaSort} onClick={onAlphaSortClick} labelKey='c_sort_alpha' />
    <IconButtonUI messageList={messageList} icon='icon-clock-o' selected={timeSort} onClick={onTimeSortClick} labelKey='c_sort_access_time' />
  </div>

const ActionTopRightUI = ({context, messageList, projectFilter, templateFilter, searchFilter,
    onProjectFilterClick, onTemplateFilterClick, onSearchFilterChange
  }) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
    <div className='g_m_left_25 type_f'>
      <input type="checkbox" checked={projectFilter} onChange={onProjectFilterClick} />
      <MessageUI messageList={messageList} messageKey='c_project' />
    </div>
    <div className='g_m_left_25 type_f'>
      <input type="checkbox" checked={templateFilter} onChange={onTemplateFilterClick} />
      <MessageUI messageList={messageList} messageKey='c_template' />
    </div>
  </div>

const ActionBtmRightUI = ({context, messageList, activeFilter, archivedFilter,
    onActiveFilterClick, onArchivedFilterClick
  }) =>
  <div className='g_flex_h'>
    <div>
      <input type="checkbox" checked={activeFilter} onChange={onActiveFilterClick} />
      <MessageUI messageList={messageList} messageKey='c_active' />
    </div>
    <div className='g_m_left_25'>
      <input type="checkbox" checked={archivedFilter} onChange={onArchivedFilterClick} />
      <MessageUI messageList={messageList} messageKey='c_archived' />
    </div>
  </div>

export default ProjectListUI
